import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowRight } from "lucide-react";
import { howItWorks } from "../data/mock";

const DiasporaNetwork = () => (
  <div>
    <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-20 pb-16">
      <div className="section-eyebrow text-[#0d2a20]/60 mb-6">Diaspora Network</div>
      <h1 className="hero-title text-[52px] md:text-[104px] leading-[0.95] max-w-[1200px]">Two hours a week. <span className="font-serif-i text-[#e0684d]">Real impact.</span></h1>
      <p className="mt-8 max-w-[820px] text-[17px] leading-relaxed text-[#0d2a20]/80">Nigeria&rsquo;s diaspora is one of its greatest untapped resources. We&rsquo;ve built the practical pathway you&rsquo;ve been looking for.</p>
    </section>

    <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pb-16 grid md:grid-cols-2 gap-6">
      <div className="rounded-lg p-8" style={{ background: '#fbf8ef' }}>
        <div className="section-eyebrow text-[#e0684d] mb-4">What you give</div>
        <ul className="space-y-3 text-[15px] text-[#0d2a20]/85">
          {['2 hours per week, for 4 weeks','Once a year (that\'s it)','A focused, high-leverage engagement matched to your skills','Pro bono — no billing, no invoices'].map(x => (
            <li key={x} className="flex gap-3 items-start"><ArrowRight size={16} className="text-[#e0684d] mt-1" />{x}</li>
          ))}
        </ul>
      </div>
      <div className="rounded-lg p-8" style={{ background: '#0f3d2e', color: '#f4efe4' }}>
        <div className="section-eyebrow text-[#f4efe4]/60 mb-4">What you get</div>
        <ul className="space-y-3 text-[15px] text-[#f4efe4]/90">
          {['Opportunities to support high-impact organisations','Monthly masterclasses on building & investing in Nigeria','Access to a serious network of professionals','In-person events and meetups'].map(x => (
            <li key={x} className="flex gap-3 items-start"><ArrowRight size={16} className="text-[#e0684d] mt-1" />{x}</li>
          ))}
        </ul>
        <Link to="/join" className="inline-flex items-center gap-2 mt-8 px-5 py-3 rounded-md btn-coral text-[14px]">Apply now — it takes 6 minutes <ArrowUpRight size={16} /></Link>
      </div>
    </section>

    <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16">
      <div className="section-eyebrow text-[#0d2a20]/60 mb-10">How it works</div>
      <div className="grid md:grid-cols-4 gap-6">
        {howItWorks.map(h => (
          <div key={h.n} className="pt-6 border-t" style={{ borderColor: 'rgba(13,42,32,0.15)' }}>
            <div className="font-serif-i text-[#e0684d] text-[32px] mb-3">{h.n}</div>
            <h4 className="text-[22px] font-medium mb-2">{h.title}</h4>
            <p className="text-[14px] leading-relaxed text-[#0d2a20]/70">{h.desc}</p>
          </div>
        ))}
      </div>
    </section>
  </div>
);

export default DiasporaNetwork;
